"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DataMapperCache {
    constructor(data) {
        this.data = data || {};
    }
    getValue(nodeId) {
        if (nodeId in this.data) {
            const value = this.data[nodeId];
            return value;
        }
        return undefined;
    }
    addValue(nodeId, value) {
        this.data[nodeId] = value;
    }
}
exports.default = DataMapperCache;
//# sourceMappingURL=Cache.js.map